module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/float-sprite-0663dd.svg";